// Vendors
import { ReactChildrenType } from '@gruposantander/opbpay-ui-core-models';
import React from 'react';
// Components
import { HeaderLayoutComponent } from 'components/header-layout/header-layout.component';
import { LoadingComponent } from 'components/loading/loading.component';
// Contexts
import { useAppInformationContextConsumerHook } from 'contexts/app-information.context';
// Constants
import { APP_INFORMATION_PROVIDER_LOADING_PROPS } from 'providers/app-information/constants/app-information.constants';
// Styles
import { AppInformationComponentStyled } from './app-information.component.styled';
// Utilities
import { allNeedDataIsLoaded } from './utils/app-information.utils';

const AppInformationProvider = ({ children }: ReactChildrenType): React.ReactElement => {
  const { informationFlags } = useAppInformationContextConsumerHook();

  return (
    <HeaderLayoutComponent>
      <AppInformationComponentStyled fetching={!allNeedDataIsLoaded(informationFlags)}>
        <LoadingComponent
          {...APP_INFORMATION_PROVIDER_LOADING_PROPS}
          fetching={!allNeedDataIsLoaded(informationFlags)}
        >
          {children}
        </LoadingComponent>
      </AppInformationComponentStyled>
    </HeaderLayoutComponent>
  );
};

export { AppInformationProvider };
